export function buildUserConversationPayload({
  userId,
  userOrgId,
  weekStarting,

  noteType, // 'Contact' | 'All'
  note,

  context = {},
}) {

    // First Created -  23 Jan 2026
    // Author -  Atul Pandey
    // Purpose - Build minimal, backend-authoritative payload for creating / updating / deleting UserConversation notes. Mirrors WABConversation contract.
  
    
    validateInputs({ userId, userOrgId, weekStarting, noteType, note });

    const payload = {
        userId,
        userOrgId,
        weekStarting,
    };

    // 🔗 Context (authoritative if provided)
    attachContext(payload, context);

    // 🧠 Route note correctly
    if (noteType === 'Contact') {
        payload.userConversationContactNotes = [normalizeContactNote(note)];
    }

    if (noteType === 'All') {
        payload.userConversationAllNotes = [normalizeAllNote(note)];
    }

    return payload;
}

/* ----------------------- Helpers ----------------------- */

function validateInputs({ userId, userOrgId, weekStarting, noteType, note }) {
  if (!userId || !userOrgId || !weekStarting) {
    throw new Error('Missing required conversation identifiers');
  }
  if (!noteType || !note) {
    throw new Error('Note and noteType are required');
  }
}

function attachContext(payload, context) {
  const {
    trailId,
    sessionId,
    selectedFocus,
    connectedEntities,
  } = context;

  if (trailId) payload.trailId = trailId;
  if (sessionId) payload.sessionId = sessionId;
  if (selectedFocus) payload.selectedFocus = selectedFocus;

  if (connectedEntities?.length > 0) {
    payload.conversationContext = { connectedEntities };
  }
}

function normalizeContactNote(note) {
  const normalized = { ...note };

  if (normalized.userConversationContactNoteText) {
    normalized.userConversationContactNoteText =
      normalized.userConversationContactNoteText.trim();
  }

  if (note.delete === true) {
    normalized.delete = true;
  }

  return normalized;
}

function normalizeAllNote(note) {
  const normalized = { ...note };

  if (normalized.userConversationAllNoteText) {
    normalized.userConversationAllNoteText =
      normalized.userConversationAllNoteText.trim();
  }

  if (note.delete === true) {
    normalized.delete = true;
  }

  return normalized;
}
